import ProductBundleCustomArrayToolbar from "./ProductBundle/CustomArrayToolbar";
import ProductIncomeCustomArrayToolbar from "./ProductIncome/CustomArrayToolbar";

export const PluginsMap: any = {
    'custom.product-bundle.array': ProductBundleCustomArrayToolbar,

    'custom.product-income.array': ProductIncomeCustomArrayToolbar,
}